import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  headerCell: {
    padding: theme.spacing(1, 2),
    '&:first-of-type': {
      paddingLeft: theme.spacing(4)
    },
    '&:last-of-type': {
      paddingRight: theme.spacing(4)
    }
  },
  cell: {
    padding: theme.spacing(1, 2),
    '&:first-of-type': {
      paddingLeft: theme.spacing(4)
    },
    '&:last-of-type': {
      paddingRight: theme.spacing(4)
    }
  },
  // A bundle's per-policy term prices, one per line in the order the Eligible Offers cell names
  // the products — which itself wraps "Home & Auto" onto two lines inside the 1200px page, so the
  // row is already two lines tall and stacking costs no height, whereas "$12,346 / $6,789" on one
  // line squeezed the address column and grew the row (#35673).
  prices: {
    display: 'block'
  },
  price: {
    display: 'block',
    whiteSpace: 'nowrap'
  },
  // "…lcunningham" must not break after the ellipsis.
  rep: {
    whiteSpace: 'nowrap'
  }
});

export default makeStyles(styles);
